import { createI18nText } from '@hilma/netina2all';

const associationText = createI18nText({
    he: {
        title: 'העמותות המשתתפות במיזם',
        register: <>לרישום עמותה<br />חדשה</>,
    },
    en: {
        title: 'The organizations participating in this project',
        register: <>Register an<br />organization</>,
    }
})

export default associationText;